export const SocketNamespaceKeys = {
  INTERVIEWER: 'interviewer',
  INTERVIEWEE: 'interviewee',
};

export const SocketChannelKeys = {
  CONNECTION: 'connection',
  INIT: 'init',
  END: 'end',
};
